import { ProcessStep } from '../../common/enums/enums';
import {
  calculateDateDifference,
  differenceDateTime,
  fromDBToLocalDateTime,
  getNewestDate,
} from '../../helpers/date';
import { isReconditioning } from '../../helpers/reconditioning';
import { calculateLatestOrder } from './StatusChips/helper';

const formatElapsedTime = duration =>
  Object.entries(duration || {})
    .map(([key, val]) =>
      val ? Math.floor(val) + key.charAt(0).toUpperCase() : ''
    )
    .filter(x => x)
    .join(' ') || '0M';

const OrderTotalTime = ({ order }) => {
  const isReconditioningOrder = isReconditioning(order);
  const latestOrderDate = calculateLatestOrder(order);
  const reconOrder = latestOrderDate
    ? formatElapsedTime(
        differenceDateTime(fromDBToLocalDateTime(latestOrderDate))
      )
    : '-';
  const notAvailable = '-';
  if (!order || !order?.step) return notAvailable;

  switch (order.step) {
    case ProcessStep.MECHANICAL:
    case ProcessStep.WHOLE_SALE:
      return '-';
    case ProcessStep.DONE: {
      if (!order.relatedOrders?.length || !order.dateOrdered)
        return notAvailable;

      const dateOrdered = fromDBToLocalDateTime(order.dateOrdered);

      const latestCompletionDate =
        getNewestDate(
          order.relatedOrders
            .filter(ro => ro.completedOn)
            .map(ro => ro.completedOn)
        ) || dateOrdered;

      return formatElapsedTime(
        calculateDateDifference(latestCompletionDate, dateOrdered)
      );
    }
    case ProcessStep.CANCELED:
    case ProcessStep.DECLINED:
      return notAvailable;
    default: {
      if (!order.dateOrdered) return notAvailable;

      return isReconditioningOrder
        ? reconOrder
        : formatElapsedTime(
            differenceDateTime(fromDBToLocalDateTime(order.dateOrdered))
          );
    }
  }
};

export default OrderTotalTime;
